import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import { useCallback, useState } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { importMomentTimezone } from 'Helpers/External';

export function useSubmitHandler({ stripe, onSubmitEvent = () => {}, onErrorEvent = () => {} }) {
  // const { promoCodeInputIsFilled } = usePromoCodeInputContext();
  const { rootNodeProps, logEvent } = useEventTrackingLogEvent({ nodeName: 'payment' });
  const [stripeError, setStripeError] = useState(undefined);
  const [stripeLoading, setStripeLoading] = useState(false);

  const {
    resource,
    onSubmit: metaSubmit,
    saving: metaSaving,
    handleChange: metaChange,
    errors: metaErrors,
  } = useMetaLayoutContext();

  // TODO: this is all a copy-pasta, we should try to adjust this to avoid the copy-pasta
  const onSubmit = useCallback(async () => {
    onSubmitEvent();
    setStripeError(undefined);

    // Call stripe.createToken, allowing for an error to be returned or thrown
    setStripeLoading(true);
    let result = {};
    try {
      result = await stripe.createToken();
    } catch (err) {
      result.error = err;
    }
    setStripeLoading(false);

    if (result.error) {
      onErrorEvent();
      setStripeError(result.error.message ?? result.error);
      return;
    }

    metaChange('stripeToken', result.token?.id);

    // None of the documentation explicitly says what this might return, so I'm wrapping this with `try` to avoid
    // causing any errors on the payment page.  If it's empty, the server will default it to EST.
    try {
      const momentTimezone = await importMomentTimezone();
      const tz = momentTimezone.tz.guess(true) || '';
      metaChange('timeZone', tz);
      metaChange('timeZoneAbbreviation', momentTimezone.tz(tz).zoneAbbr() || '');
        } catch (_) {} // eslint-disable-line

    await metaSubmit();
  }, [stripe, metaSubmit, metaChange, logEvent]);

  return {
    rootNodeProps,
    onSubmit,
    stripeError,
    metaErrors,
    loading: metaSaving || stripeLoading,
    disabled: resource.attr('agreementCheckbox') !== 'true',
  };
}
